import store from '../store'
import { sidebarLayer } from '../config/project.config'
import DefaultLayout from '../views/layout/DefaultLayout.vue'

const _import = require('./' + process.env.NODE_ENV + '.js')

// meta 对象字段信息
// category： 路由分类，
// baseCategory：所属类目，
// title: 路由标题，
// hidden: 是否在导航中显示，
// icon：图标
// activeIcon：active图标
// rightName: 与后端约定的权限code
// permissions：所属的权限类目，限定路由的所属权限 list从project.config.js导入
// sidebarLayer: sidebar层级,控制导航显示的层次 从project.config.js导入
console.log(store.getters.indexRouter)
export const authRouterList = [
  {
    path: '/',
    name: 'DefaultLayout',
    component: DefaultLayout,
    redirect: () => {
      return {
        name: store.getters.indexRouter
      }
    },
    children: [
      {
        path: 'campus',
        name: 'campusManage',
        component: _import('campus/CampusManage'),
        meta: {
          title: '成长管理',
          category: 'campus',
          rightName: '成长管理',
          sidebarLayer: sidebarLayer.superLayer
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'courseManage'
        },
        children: [
          {
            path: 'courseManage',
            name: 'courseManage',
            component: _import('campus/course/courseManage'),
            meta: {
              title: '创新课程',
              category: 'campus',
              rightName: '活动',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            },
            redirect: {
              name: 'courseIndex'
            },
            children: [
              {
                path: 'courseIndex',
                name: 'courseIndex',
                component: _import('campus/course/courseIndex'),
                meta: {
                  title: '创新课程',
                  category: 'campus',
                  rightName: '创新课程',
                  sidebarLayer: sidebarLayer.superLayer
                  // icon: require('../assets/img/icon/所有校区.png')
                }
              },
              {
                path: 'editIndex/:id',
                name: 'editIndex',
                component: _import('campus/course/editIndex'),
                meta: {
                  title: '编辑课程',
                  category: 'campus',
                  rightName: '创新课程',
                  hidden: true,
                  sidebarLayer: sidebarLayer.superLayer
                  // icon: require('../assets/img/icon/所有校区.png')
                }
              }
            ]
          },
          {
            path: 'maintain',
            name: 'maintain',
            component: _import('campus/maintain'),
            meta: {
              title: '赛事编辑',
              category: 'campus',
              rightName: '赛事编辑',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          },
          {
            path: 'train/:id',
            name: 'train',
            component: _import('campus/matchTrains'),
            meta: {
              title: '赛事编辑',
              category: 'campus',
              rightName: '赛事编辑',
              hidden:true,
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          },
          {
            path: 'Administration',
            name: 'Administration',
            component: _import('campus/Administration'),
            meta: {
              title: '赛事管理',
              category: 'campus',
              rightName: '赛事管理',
              sidebarLayer: sidebarLayer.superLayer

              // icon: require('../assets/img/icon/所有校区.png')
            },
            redirect: {
              name: 'matchList'
            },
            children: [
              {
                path: 'matchList',
                name: 'matchList',
                component: _import('campus/matchList'),
                meta: {
                  title: '项目列表',
                  category: 'campus',
                  rightName: '赛事维护',
                  sidebarLayer: sidebarLayer.superLayer
                  // icon: require('../assets/img/icon/所有校区.png')
                }
              },
              {
                path: 'matchAdministration',
                name: 'matchAdministration',
                component: _import('campus/matchAdministration'),
                meta: {
                  title: '项目列表',
                  category: 'campus',
                  rightName: '赛事维护',
                  sidebarLayer: sidebarLayer.superLayer
                  // icon: require('../assets/img/icon/所有校区.png')
                }
              }
            ]
          },
          {
            path: 'activityManage',
            name: 'activityManage',
            component: _import('campus/activityManage'),
            meta: {
              title: '活动',
              category: 'campus',
              rightName: '活动',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            },
            redirect: {
              name: 'activity'
            },
            children: [
              {
                path: 'activity',
                name: 'activity',
                component: _import('campus/activity'),
                meta: {
                  title: '活动',
                  category: 'campus',
                  rightName: '活动',
                  sidebarLayer: sidebarLayer.superLayer
                  // icon: require('../assets/img/icon/所有校区.png')
                }
              },
              {
                path: 'activityMenber/:id',
                name: 'activityMenber',
                component: _import('campus/activityMenber'),
                meta: {
                  title: '活动',
                  category: 'campus',
                  rightName: '活动',
                  hidden: true,
                  sidebarLayer: sidebarLayer.superLayer
                  // icon: require('../assets/img/icon/所有校区.png')
                }
              },
              {
                path: 'editItem',
                name: 'editItem',
                component: _import('campus/editItem'),
                meta: {
                  title: '编辑活动',
                  category: 'campus',
                  rightName: '活动',
                  hidden: true,
                  sidebarLayer: sidebarLayer.superLayer
                  // icon: require('../assets/img/icon/所有校区.png')
                }
              },
              {
                path: 'sponsor',
                name: 'sponsor',
                component: _import('campus/sponsor'),
                meta: {
                  title: '编辑主办方',
                  category: 'campus',
                  rightName: '活动',
                  hidden: true,
                  sidebarLayer: sidebarLayer.superLayer
                  // icon: require('../assets/img/icon/所有校区.png')
                }
              }
            ]
          },

          {
            path: 'trainingCamp',
            name: 'trainingCamp',
            component: _import('campus/trainingCamp/trainingCamp'),
            meta: {
              title: '训练营',
              category: 'campus',
              rightName: '训练营',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          },
          {
            path: 'trainingCampMember/:id',
            name: 'trainingCampMember',
            component: _import('campus/trainingCamp/trainingCampMember'),
            meta: {
              title: '训练营',
              category: 'campus',
              hidden: true,
              rightName: '训练营',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          },
          {
            path: 'campSponsor',
            name: 'campSponsor',
            component: _import('campus/trainingCamp/campSponsor'),
            meta: {
              title: '编辑主办方',
              category: 'campus',
              rightName: '活动',
              hidden: true,
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          },
          {
            path: 'campEditItem',
            name: 'campEditItem',
            component: _import('campus/trainingCamp/campEditItem'),
            meta: {
              title: '编辑训练营',
              category: 'campus',
              rightName: '活动',
              hidden: true,
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          }
        ]
      },
      {
        path: 'fund',
        name: 'fundMange',
        component: _import('fund/fundMange'),
        meta: {
          title: '服务模块',
          category: 'fund',
          rightName: '基金管理',
          sidebarLayer: sidebarLayer.superLayer
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'fundList'
        },
        children: [
          {
            path: 'fundList',
            name: 'fundList',
            component: _import('fund/fundList'),
            meta: {
              title: '基金维护',
              category: 'fund',
              rightName: '基金维护',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          },
          {
            path: 'fundMember/:id',
            name: 'fundMember',
            component: _import('fund/fundMember'),
            meta: {
              title: '基金维护',
              category: 'fund',
              rightName: '基金维护',
              hidden: true,
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          },
          {
            path: 'outside',
            name: 'outside',
            component: _import('fund/outsideServe'),
            meta: {
              title: '外部服务',
              category: 'fund',
              rightName: '基金维护',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          }
        ]
      },
      {
        path: 'community',
        name: 'communityMange',
        component: _import('community/communityMange'),
        meta: {
          title: '社区管理',
          category: 'community',
          rightName: '社区管理',
          sidebarLayer: sidebarLayer.superLayer
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'release'
        },
        children: [
          {
            path: 'release',
            name: 'release',
            component: _import('community/release'),
            meta: {
              title: '动态管理',
              category: 'community',
              rightName: '动态管理',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          },
          {
            path: 'examine',
            name: 'examine',
            component: _import('community/examine'),
            meta: {
              title: '动态审核',
              category: 'community',
              rightName: '动态审核',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          }
        ]
      },
      {
        path: 'users',
        name: 'users',
        component: _import('users/userManage'),
        meta: {
          title: '用户管理',
          category: 'users',
          rightName: '用户管理',
          sidebarLayer: sidebarLayer.superLayer
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'userAdministration'
        },
        children: [
          {
            path: 'userAdministration',
            name: 'userAdministration',
            component: _import('users/userAdministration'),
            meta: {
              title: '人员管理',
              category: 'users',
              rightName: '人员管理',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          }
        ]
      },
      {
        path: 'match',
        name: 'match',
        component: _import('match/matchMange'),
        meta: {
          title: '项目管理',
          category: 'match',
          rightName: '项目管理',
          sidebarLayer: sidebarLayer.superLayer
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'matchAdministrationN'
        },
        children: [
          {
            path: 'matchAdministrationN',
            name: 'matchAdministrationN',
            component: _import('match/matchAdministrationN'),
            meta: {
              title: '项目维护',
              category: 'match',
              rightName: '项目维护',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          },
          {
            path: 'perfectMatch/:id',
            name: 'perfectMatch',
            component: _import('match/perfectMatch'),
            meta: {
              title: '项目完善',
              category: 'match',
              hidden: true,
              rightName: '项目维护',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          },
          {
            path: 'prizeData/:id',
            name: 'prizeData',
            component: _import('match/prizeData'),
            meta: {
              title: '获奖信息',
              category: 'match',
              hidden: true,
              rightName: '项目维护',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          }
        ]
      },
      {
        path: 'news',
        name: 'news',
        component: _import('news/newsManage'),
        meta: {
          title: '消息通知',
          category: 'news',
          rightName: '消息通知',
          sidebarLayer: sidebarLayer.superLayer
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'newsRelease'
        },
        children: [
          {
            path: 'newsRelease',
            name: 'newsRelease',
            component: _import('news/newsRelease'),
            meta: {
              title: '新闻动态发布',
              category: 'news',
              rightName: '新闻动态发布',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          },
          {
            path: 'ai',
            name: 'ai',
            component: _import('news/ai'),
            meta: {
              title: 'AI助手',
              category: 'news',
              rightName: 'AI助手',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          },
          {
            path: 'editNews/:id',
            name: 'editNews',
            component: _import('news/editNews'),
            meta: {
              title: '编辑',
              category: 'news',
              rightName: '新闻动态发布',
              sidebarLayer: sidebarLayer.superLayer,
              hidden: true
            }
          },
          {
            path: 'push',
            name: 'push',
            component: _import('news/newsPush'),
            meta: {
              title: '个性化推送',
              category: 'news',
              rightName: '个性化推送',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          }
        ]
      },
      {
        path: 'base',
        name: 'base',
        component: _import('base/baseMange'),
        meta: {
          title: '基地管理',
          category: 'base',
          rightName: '基地管理',
          sidebarLayer: sidebarLayer.superLayer
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'baseIndex'
        },
        children: [
          {
            path: 'baseIndex',
            name: 'baseIndex',
            component: _import('base/baseIndex'),
            meta: {
              title: '基地入驻',
              category: 'base',
              rightName: '基地入驻',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          },
          {
            path: 'baseadmission',
            name: 'baseadmission',
            component: _import('base/baseadmission'),
            meta: {
              title: '入校申请',
              category: 'base',
              rightName: '入校申请',
              sidebarLayer: sidebarLayer.superLayer
              // icon: require('../assets/img/icon/所有校区.png')
            }
          }
        ]
      },
      {
        path: 'home',
        name: 'home',
        component: _import('home/index'),
        meta: {
          category: 'home',
          hidden: true
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404'
  }
]
